<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="complaintState" >
        <el-select v-model="queryParams.complaintState" filterable placeholder="投诉状态" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="complaintId">
        <el-input v-model="queryParams.complaintId" placeholder="投诉单号"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="iccid">
        <el-input v-model="queryParams.iccid" placeholder="ICCID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="orderNum" >
        <el-input v-model="queryParams.orderNum" placeholder="微信支付订单号"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="mchId">
          <el-select v-model="queryParams.mchId" filterable placeholder="支付账号" @change="search" clearable >
            <el-option v-for="item in mchSources" :key="item.mchId" :label='item.mchId+"-"+item.name' :value="item.mchId"></el-option>
          </el-select>
        </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-full-screen" @click="nowUpdate">立即更新</el-button>
      </el-form-item>
    </el-form>
    <div class="processingData">
      <div class="processingData-left">
        <div class="shuju">
          <p class="p1">待处理</p>
          <p class="p2">
            <span style="font-size: 40px;color: #659ad2;font-weight: 700;">{{singular.pendingCount}}</span>
            <span style="font-size: 16px;color: #659ad2;font-weight: 700;">单</span>
          </p>
        </div>
        <div class="shuju">
          <p class="p1">处理中</p>
          <p class="p2">
            <span style="font-size: 40px;color: #659ad2;font-weight: 700;">{{singular.processingCount}}</span>
            <span style="font-size: 16px;color: #659ad2;font-weight: 700;">单</span>
          </p>
        </div>
        <div class="shuju">
          <p class="p1">今日已处理</p>
          <p class="p2" style="border:none">
            <span style="font-size: 40px;color: #333;font-weight: 700;">{{singular.processedCount}}</span>
            <span style="font-size: 16px;color: #333;font-weight: 700;">单</span>
          </p>
        </div>
      </div>
      <div class="processingData-right"> 
        <p>
          <span>未处理售后时长：</span>
          <span>{{singular.lastPendingTime + "h"}}</span>
        </p>
        <p>
          <span>处理售后及时率：</span>
          <span>100%</span>
        </p>
        <p>
          <span>售后率：</span>
          <span>100%</span>
        </p>
      </div>
    </div>
    <el-table :data="tableData" border :cell-style="tableRowStyleName" @sort-change="tableSortChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="24">
                <!-- 缩小距离展示  避免影藏过多内容 -->
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="是否有待回复的用户留言：" >
                        <el-tag v-if="props.row.incomingUserResponse == '1'" type="danger">是</el-tag>
                        <el-tag v-else type="success">否</el-tag>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="是否需即时服务用户：" >
                        <el-tag v-if="props.row.needImmediateService == '1'" type="danger">是</el-tag>
                        <el-tag v-else type="success">否</el-tag>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="已退款金额：" >
                      <span>{{ props.row.refundAmount }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="是否已开发票：" >
                      <el-tag v-if="props.row.isInvoice == '1'" type="success">是</el-tag>
                      <el-tag v-else>否</el-tag>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-row>
                      <el-col :span="6">
                        <el-form-item label="操作人：" >
                            {{props.row.finishPersonName}}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                
              </el-col>
            </el-row>
            
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="complaintId" label="投诉单号" align="center" width="230px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div @click="JumpDetails(scope.row.complaintId)" class="complaint-class" style="color: #4466AD;">{{ scope.row.complaintId }}</div>
          <div v-if="scope.row.type =='1'">微信：{{ scope.row.mchId }}</div>
          <div v-else>支付宝：{{ scope.row.mchId }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" sortable="custom" align="center" width="160px"></el-table-column>
      <el-table-column prop="complaintTime" label="投诉/结束时间" sortable="custom" align="center" width="160px">
        <template slot-scope="scope">
          <div class="time-info">
            <div class="complaint-time">{{ scope.row.complaintTime }}</div>
            <div class="finish-time">{{ scope.row.finishTime || '-' }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="problemDescription" label="问题类型" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="complaintDetail" label="投诉内容" align="center" :show-overflow-tooltip="true" width="150px"></el-table-column>
      <el-table-column prop="amount" label="投诉金额" align="center" width="90px">
        <template slot-scope="scope">
          <div>{{ scope.row.amount }}</div>
          <!-- 已经全额退款 -->
          <p style="cursor: pointer; color: #13ce66;" v-if=" scope.row.complaintFullRefunded == '0'" class="refundHover" @click="refund(scope.row.orderNum)">退款</p>
          <p style="cursor: pointer;" v-else class="refundHover" @click="noRefund()">退款</p>
        </template>
      </el-table-column>
      <el-table-column prop="iccid" label="ICCID/投诉人电话" align="center"  width="185px">
        <template slot-scope="scope">
          <div style="color: #4466AD;" class="complaint-class" @click="jumpCardDetails(scope.row.iccid)">{{ scope.row.iccid }}</div>
          <div style="color: #000;">{{ scope.row.phone }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="phone" label="投诉人电话" align="center" width="120px" :show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column prop="userComplaintTimes" label="投诉次数" align="center" width="80px"></el-table-column>
      <el-table-column prop="orderNum" label="支付单号" align="center" min-width="190px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <p>{{ scope.row.orderNum }}</p>
          <p>{{ scope.row.mchName }}</p>
          <!-- <p>{{ scope.row.mchId }}</p> -->
        </template>
      </el-table-column>
      <el-table-column prop="complaintState" label="投诉单状态" align="center" width="100px" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <span v-if="row.complaintState =='2'" style="color: red;">待处理</span>
          <span v-else-if="row.complaintState =='3'" style="color: red;">处理中</span>
          <span v-else-if="row.complaintState =='4'">已完成</span>
          <span v-else-if="row.complaintState =='5'" style="color: red;">部分超时未处理</span>
          <span v-else-if="row.complaintState =='6'">超时处理完成</span>
          <span v-else-if="row.complaintState =='7'" style="color: red;">超时未处理</span>
          <span v-else-if="row.complaintState =='8'">处理完成用户撤诉</span>
          <span v-else-if="row.complaintState =='9'" >超时处理完成用户撤诉</span>
          <span v-else-if="row.complaintState =='10'">超时后用户撤诉</span>
          <span v-else-if="row.complaintState =='11'">用户撤诉</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <p v-hasPermi="['message:user:detailComplaints']">
            <el-link  type="primary" :underline="false"  icon="el-icon-chat-dot-round"    @click="JumpDetails(scope.row.complaintId)">回复<el-badge :hidden="scope.row.unread == 0" :value="scope.row.unread"></el-badge></el-link>
          </p>
          <p v-hasPermi="['message:user:finishComplaints']"><el-link  type="success" :underline="false"  icon="el-icon-finished"  @click="endSession(scope.row.complaintId)">结束</el-link></p>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import { complainList } from "@/api/api.js"; //微信投诉列表
import { complainCount } from "@/api/api.js"; //获取投诉率的数据
import { complainFinishComplaint } from "@/api/api.js"; //微信投诉结束任务
import { complainUpdateList } from "@/api/api.js"; //立即更新微信投诉列表
import { payConfigSource } from "@/api/api.js"; //收款账号
export default {
  name:'complaintList',
  data() {
    return{
      mchSources:[],
      queryParams:{
        complaintState:undefined,
        complaintId:undefined,
        iccid:undefined,
        orderNum:undefined
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      dateRange:[],
      operator:[
        { value: 2, label: "待处理" },
        { value: 3, label: "处理中" },
        { value: 4, label: "已完成" },
        { value: 5, label: "部分超时未处理" },
        { value: 6, label: "超时处理完成" },
        { value: 7, label: "超时未处理" },
        { value: 8, label: "处理完成用户撤诉" },
        { value: 9, label: "超时处理完成用户撤诉" },
        { value: 10, label: "超时后用户撤诉" },
        { value: 11, label: "用户撤诉" },
      ],
      singular:{},
      sortOrder: "",
      // 排序名称
      sortName: "",
    }
  },
  methods: {
    tableRowStyleName({row}) {
      if(row.incomingUserResponse == "1"){
        return 'background-color: #F0F9EB !important;';
      }
    },
    tableSortChange(val){
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      if(val.prop == 'updateTime'){
        this.sortName = 'updateTime'
      }else if(val.prop == 'complaintTime'){
        this.sortName = 'complaintTime'
      }
      if(!val.order){
        this.sortOrder = undefined
        this.sortName = undefined
      }
      this.initData()
    },
    //获取所有支付商号
    mchSource(){
      payConfigSource({}).then(res=>{
        this.mchSources = res.data.data;
      })
    },
    // 获取列表的数据
    initData(){
      let params = {
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize
      }
      complainList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 获取投诉率的数据
    complaintData(){
      complainCount().then(res=>{
        this.singular = res.data.data;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
      this.complaintData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.sortName = ""
      this.sortOrder = ""
      this.resetForm("queryForm");
      this.search();
    },
    // 跳转详情
    JumpDetails(orderNum){
      this.$router.push(`/user/complaints/detail/`+orderNum)
    },
    // 跳转卡的详情
    jumpCardDetails(iccid){
      this.$router.push({path:"/card/detail",query:{iccid: iccid}});
    },
    // 结束任务
    endSession(id){
      this.$confirm('结束投诉, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          complaintId:id,
        }
        complainFinishComplaint(params).then(res=>{
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '结束投诉成功!'
            });
            this.initData();
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消投诉任务'
        });  
      })
    },
    // 立即更新
    nowUpdate(){
      complainUpdateList({}).then(res=>{
        if (res.data.code == 200) {
          this.$message({
            message: '立即更新成功',
            type: 'success'
          });
          this.initData();
        }
      })
    },
    // 退款跳转
    refund(orderNum){
      this.$router.push({path:"/order/refundDetail",query:{orderNum: orderNum}});
    },
    // 不跳转
    noRefund(){
      return this.$message.error('投诉订单已全额退款');
    }
  },
  mounted() {
    this.mchSource()
    this.initData();
    this.complaintData();
  },
  created() {
    
  }
};
</script>
<style scoped lang="less">
.refundHover:hover{
  text-decoration: underline;
}
.processingData{
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .processingData-left{
    width: 74%;
    height: 180px;
    border: 1px solid #e7eaf0;
    background-color: #fff;
    display: flex;
    align-items: center;
    .shuju{
      text-align: center;
      width: 33%;
      height: 130px;
      .p1{
        color: #333;
      }
      .p2{
        height: 55px;
        line-height: 55px;
        margin-top: 15px;
        border-right: 3px solid #e0e0e0;
      }
      .p3{
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #999;
        margin-top: 5px;
      }
    }
  }
  .processingData-right{
    width: 25%;
    height: 180px;
    border: 1px solid #e7eaf0;
    background-color: #fff;
    p{
      height: 20px;
      line-height: 20px;
      color: #999;
      margin: 30px 0px 0px 30px;
    }
  }
}
.complaint-class:hover{
  text-decoration: underline;
  cursor: pointer;
}
/deep/ .el-textarea__inner{
  resize:none;
}
.time-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  .complaint-time {
    color: #4466AD; /* 投诉时间蓝色 */
    font-size: 13px;
  }
  
  .finish-time {
    color: #67C23A; /* 结束时间绿色 */
    font-size: 13px;
  }
}
.table-expand{
  margin-left: 20px;
  label{
    width: 90px;
    color: #99a9bf; 
  }
  .el-form-item{
    margin-bottom: 0;
  }
}
</style>


